__turbopack_context__.v({
  "items": "GJ6nta_items",
  "message": "GJ6nta_message",
  "tabPanel": "GJ6nta_tabPanel",
});
